export default function Subtitle({
  children,
  subtitleAs = "h3", // default tag
  size = "16px",
  lineHeight = "24px",
  fontWeight = "800",
  className = "",
  color = "subtitle-color",
}) {
  const Tag = subtitleAs;

  return (
    <Tag
      className={`${color} ${className} line-clamp-3`}
      style={{
        fontSize: size,
        lineHeight,
        fontWeight,
      }}
    >
      {children}
    </Tag>
  );
}
